import React from "react";

const About = () => {
  return (
    <div name="about" className="w-full h-screen text-gray-200">
      <title>Portfolio Website</title>
      <div className="flex flex-col justify-center items-center w-full h-full">
        <div className="flex items-center justify-center w-full">
          <p className="text-5xl font-bold inline border-b-4 border-red-600 ">
            About Me
          </p>
        </div>
        <div className="max-w-[900] w-full grid sm:grid-cols-2 gap-8 px-4 flex">
          <div className="sm:text-right text-4xl mt-10 font-bold flex items-center justify-center">
            <p>Hi, Glad you are here. You can know about me here.</p>
          </div>
          <div>
            <p className="lg:my-10 sm:text-0.8xl items-center">
              I am a Final Year CSBS Student. I am a passionate Web Developer
              familiar in{" "}
              <span className="text-indigo-400">
                <b>
                  <i>React JS</i>
                </b>
              </span>
              ,{" "}
              <span className="text-gray-400">
                <b>
                  <i>Next JS</i>
                </b>
              </span>
              ,{" "}
              <span className="text-red-400">
                <b>
                  <i>Node JS</i>
                </b>
              </span>
              ,{" "}
              <span className="text-yellow-400">
                <b>
                  <i>Mongo DB</i>
                </b>
              </span>{" "}
              and{" "}
              <span className="text-violet-400">
                <b>
                  <i>Tailwind CSS</i>
                </b>
              </span>
              . Currently I am learning Backend Development using Python Django
              Framework. I would love to learn new Technologies. I am a{" "}
              <span className="text-green-400">
                <b>
                  <i>4 Star Python Developer in Hackerrank </i>
                </b>
              </span>{" "}
              and{" "}
              <span className="text-red-400">
                <i>
                  <b> 200+ Problem solver in Leetcode</b>
                </i>
              </span>{" "}
              . I am a self taught Video Editor. I am a Video Editor familiar in
              softwares like{" "}
              <span className="text-red-300">
                <b>
                  <i>Adobe Premiere Pro</i>
                </b>
              </span>
              ,{" "}
              <span className="text-blue-300">
                <b>
                  <i>Adobe After Effects</i>
                </b>
              </span>{" "}
              and{" "}
              <span className="text-yellow-300">
                <b>
                  <i>daVinci Resolve</i>
                </b>
              </span>{" "}
              (Especially for Color Grading). I have done many virtual
              Internships on Web Development and Video Editing in Internshala,
              Fiverr and Indeed Platform. If you need some work to be done, You can contact me.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
